module.exports = __webpack_public_path__ + "media/img/corporate/woman_in_banking-a9836bf3797852fabca8e282bedde4c3.png";